import type { ValidationResult } from 'joi';

import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { UserRequestName } from '../../../user-request-name';
import { UserResponse } from '../../generic/user-response/user-response';
import { UserResponseSchema } from '../../generic/user-response/user-response-schema';

import { UserResponseCreateOrgConstructor } from './user-response-create-org-constructor';
import { UserResponseCreateOrgError } from './user-response-create-org-error';
import { UserResponseCreateOrgSchema } from './user-response-create-org-schema';

export class UserResponseCreateOrg extends UserResponse<UserResponseCreateOrgError> {
  protected orgId?: string;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: UserResponseCreateOrgConstructor) {
    super({
      ...parameters,
      [UserResponseSchema.type]: UserRequestName.createOrg,
    });
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(validationResult: ValidationResult): UserResponseCreateOrg {
    return new UserResponseCreateOrg(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new UserResponseCreateOrgSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(UserResponseCreateOrg.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getOrgId(): string | undefined {
    return this.orgId;
  }
}
